import React from "react";
import { withRouter } from "react-router";
import { Empty, Table } from "antd";
import {
  showInfoAlert,
  showColumnFeature,
  showColumnStoreType,
  showColumnAction,
} from "./GroupTableColumn";
import "./GroupTable.css";
import QRGenerator from "components/QRCodeGenerator/qrGenerator";
import moment from "moment";
import { numberWithCommas } from "utils/GlobalFunctions";
import useTablePagination from "hooks/useTablePagination";
function GroupTable(props) {
  const { dataList, group, onDetail } = props;
  const pagination = useTablePagination();
  if (dataList === undefined) return <div />;

  const columns = [
    {
      title: group,
      render: (info) => {
        return <span>{info.label_name}</span>;
      },
    },
    {
      title: "Participant Count",
      dataIndex: "reg_count",
    },
    {
      title: "Total Reg",
      dataIndex: "total_reg",
      render: (info) => {
        return "$" + numberWithCommas(info);
      },
    },
  ];

  const dataSource = dataList.map((data, index) => {
    return { ...data, key: index };
  });
  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      rowClassName={"club-table-row"}
      onRow={(record, rowIndex) => ({
        onClick: () => {
          onDetail(record.label_name);
        },
        style: { cursor: 'pointer' }
      })}
      locale={{
        emptyText: (
          <div>
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No Registrations Found"
            ></Empty>
          </div>
        ),
      }}
      scroll={{ x: 900 }}
      pagination={pagination}
    />
  );
}

export default withRouter(GroupTable);
